import { TemplateLanguageStatus } from './TemplateLanguageStatus';

export enum TemplateType {
  DataAcquisition = 'emailAcquisition',
  SendMyBasket = 'sendMyBasket',
  CartAbandonment = 'cartAbandonment',
  DisplayOnly = 'displayOnly',
  BulkRetargeting = 'bulkRetargeting',
  MpsPopup = 'mpsPopup',
  MpsEmbed = 'mpsEmbed',
}

export interface Template {
  audit: {
    comment: string;
    createdAt: string;
    createdBy: string;
    lastUpdatedAt: string;
    lastUpdatedBy: string;
    s3VersionId: string;
  };
  channel: string;
  type: TemplateType;
  isEmbedded: boolean;
  id: string;
  siteId: string;
  template: string;
  templateName: string;
  enrichmentConfigIds: string[];
  supportedLanguages: TemplateLanguageStatus[];
}
